import Cookies from 'js-cookie';
import { setDefaultPixelData } from '@yme/utils/bloomreach/helpers';
import { mimicDelay } from '../mimicDelay';
import { BLOOM_REACH_SCRIPT_LOADED, PixelEvent, PixelEventAction, PixelEventGrouping, PixelPageView, } from './constants';
let resolve;
const brScriptLoaded = new Promise((res) => {
    resolve = res;
});
function bloomReachScriptListener() {
    resolve(1);
}
function getWindow() {
    return window;
}
export function getBrData() {
    if (!('br_data' in getWindow())) {
        getWindow().br_data = {
            acct_id: '',
            ptype: '',
            title: '',
            domain_key: '',
        };
    }
    const data = getWindow().br_data ?? {};
    for (const key in data) {
        if (![
            'acct_id',
            'ptype',
            'title',
            'domain_key',
            'orig_ref_url',
            'ref_url',
            'debug',
            'test_data',
        ].includes(key)) {
            delete data[key];
        }
    }
    return data;
}
export async function getBrTrk() {
    if (!('BrTrk' in getWindow())) {
        document.addEventListener(BLOOM_REACH_SCRIPT_LOADED, bloomReachScriptListener);
        await brScriptLoaded;
        document.removeEventListener(BLOOM_REACH_SCRIPT_LOADED, bloomReachScriptListener);
        return getWindow().BrTrk;
    }
    return getWindow().BrTrk;
}
export async function setPixelPageView(type, 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
payload) {
    if (!Cookies.get('OptanonAlertBoxClosed'))
        return;
    if (!Cookies.get('OptanonConsent')?.includes('C0004:1'))
        return;
    const BrTrk = await getBrTrk();
    if (!BrTrk)
        return;
    const br_data = getBrData();
    // need delay to wait react-helmet set up document title
    await mimicDelay();
    // Global tracking parameters
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setDefaultPixelData(br_data, String(BrTrk.acctId), payload.domain_key, type);
    if (type === PixelPageView.PRODUCT_PAGE) {
        const { prod_id, prod_name, sku } = payload;
        br_data.prod_id = prod_id;
        br_data.prod_name = prod_name;
        br_data.sku = sku;
    }
    if (type === PixelPageView.CATEGORY) {
        const { cat_id, cat } = payload;
        br_data.cat_id = cat_id;
        br_data.cat = cat;
    }
    if (type === PixelPageView.CONTENT) {
        const { catalogs, item_id, item_name } = payload;
        br_data.catalogs = catalogs;
        br_data.item_id = item_id;
        br_data.item_name = item_name;
    }
    if (type === PixelPageView.CONVERSION) {
        const { basket, basket_value, currency, is_conversion, order_id } = payload;
        br_data.basket = basket;
        br_data.basket_value = basket_value;
        br_data.currency = currency;
        br_data.is_conversion = is_conversion;
        br_data.order_id = order_id;
    }
    if (type === PixelPageView.SEARCH) {
        const { catalogs, search_term } = payload;
        br_data.catalogs = catalogs;
        br_data.search_term = search_term;
    }
    BrTrk.getTracker().updateBrData(br_data);
    BrTrk.getTracker().logPageView();
}
export async function setPixelEvent(type, payload) {
    const BrTrk = await getBrTrk();
    if (!BrTrk)
        return;
    const br_data = getBrData();
    br_data.acct_id = String(BrTrk.acctId);
    br_data.title = document.title;
    br_data.domain_key = payload.domain_key;
    BrTrk.getTracker().updateBrData(br_data);
    if (type === PixelEvent.ADD_TO_CART) {
        const { prod_id, sku } = payload;
        BrTrk.getTracker().logEvent(PixelEventGrouping.CART, PixelEventAction.CLICK_ADD, {
            prod_id,
            sku,
        });
    }
    if (type === PixelEvent.SEARCH) {
        const { q } = payload;
        BrTrk.getTracker().logEvent(PixelEventGrouping.SUGGEST, PixelEventAction.SUBMIT, {
            q,
        });
    }
    if (type === PixelEvent.SUGGEST) {
        const { aq, q } = payload;
        BrTrk.getTracker().logEvent(PixelEventGrouping.SUGGEST, PixelEventAction.CLICK, {
            aq,
            q,
        });
    }
}
